import type { ComposedOrganization } from '@UI/Providers/CurrentOrganizationProvider/helpers/composeAssignedOrganizations';

const countAssignedFacilities = (organizations: readonly ComposedOrganization[]): number =>
	organizations.reduce((total, organization) => total + organization.facilities.length, 0);

export default countAssignedFacilities;
